'use strict';

var moment = require('moment-timezone');

/** ## Time
 * A static set of helpers for working with time that is represented as seconds-from-midnight
 */
var Time = {
  /** #### Time.at()
   * A convenient way for turning a time of day into a seconds-from-midnight.
   * Use like `Time.at(16, 20)` or `Time.at(9, 30, 59)`
   * @param {...number} parameters Accepts (hours, minutes) or (hours, minutes, seconds)
   * @returns {number} The number of seconds specified by the input parameters
   */
  at: function at() {
    if (arguments.length == 2) { // (hours, minutes)
      return (arguments[0] * 60 * 60) + (arguments[1] * 60);
    } else if (arguments.length == 3) { // (hours, minutes, seconds)
      return (arguments[0] * 60 * 60) + (arguments[1] * 60) + arguments[2];
    } else {
      throw new TypeError('Time#at expects arguments like (hours, minutes[, seconds])');
    }
  },

  /** #### Time.span()
   * Alias to Time.at(), for a more semantically-correct sounding way of using this for representing durations.
   *
   * **NOTE::** deprecated, use `Duration.make()` instead
   * @param {...number} parameters Accepts (hours, minutes) or (hours, minutes, seconds)
   * @returns {number}
   */
  span: function span() {
    return Time.at.apply(this, arguments);
  },

  format: function format(value) {
    if (arguments.length != 1) {
      value = Time.at.apply(this, arguments);
    }
    return moment({ hours: Math.floor(value / (60 * 60)), minutes: Math.floor(value / 60) % 60, seconds: value % 60 }).format('LT');
  },

  formatJSON: function formatJSON(time) {
    if (typeof(time) == 'number' && !isNaN(time)) {
      return moment.utc(time * 1000).format('H:mm:ss');
    } else {
      return null;
    }
  },

  parseJSON: function parseJSON(timeString) {
    try {
      var parts = timeString.split(':');
      var hours = parseInt(parts[0]);
      var minutes = parseInt(parts[1]);
      var seconds = parseInt(parts[2]);
      var result = (hours * 60 * 60) + (minutes * 60) + seconds;
      return (isNaN(result)) ? null : result;
    } catch(e) {
      return null;
    }
  },

  getCurrentTime: function() {
    return moment().format();
  },

  //This function converts a moment (MomentJS object) to a time-of-day expressed as a number-of-seconds
  convertMomentToTimeInSeconds: function (timeMoment) {
    //NOTE:: this is the correct implementation - it works properly with DST - doing a diff to .startOfDay() produces UNEXPECTED RESULTS on the day of a DST change (midnight on DST forward + 5 hours == 6:00am)
    return (timeMoment.hour() * 60 * 60) + (timeMoment.minute() * 60) + timeMoment.second();

    //NOTE:: this implementation is WRONG - you will get unexpected results on days with DST transitions since the actual seconds-since-midnight does not match time-of-day
    //timeMoment.diff(timeMoment.clone().startOf('day'), 'seconds');
  },

  //This function will return a new moment, setting the time-of-day based on the time that was passed in seconds (14:24:39 == (14*60*60)+(24*60)+39 seconds)
  //This implementation is correct - it gives you the exact time-of-day that you request even during DST transitions
  getNewMomentWithTimeOfDayBySecond: function(dateMoment, seconds) {
    return dateMoment.clone().set({
      hour: Math.floor(seconds / (60*60)),
      minute: Math.floor((seconds % (60 * 60)) / 60),
      second: seconds % 60,
      millisecond: 0
    });
  },

  computeWaitingDateTime: function(store, estimatedServiceTime) {
    var storeTime = store.getLocalTime();
    return storeTime.clone().add(estimatedServiceTime, 'seconds').format();
  },

  roundToResolution: function(time, resolution, roundUp) {
    var extraTime = time % resolution;
    if (extraTime > 0) {
      if (roundUp) {
        return time + resolution - extraTime;
      } else {
        return time - extraTime;
      }
    } else {
      return time;
    }
  },

  secondsToMinutes: function(value) {
    return Math.round(value / 60);
  }

};

module.exports = Time;